import * as React from 'react'

import { Box, Flex, Stack } from '@enechain/ecloud-designsystem'

type Props = {
  children: React.ReactNode
}

const FIXED_WIDTH = 960

const fixedContent: React.FC<Props> = ({ children }) => {
  const [windowWidth, setWindowWidth] = React.useState<number>(0)

  const updateWindowWidth = React.useCallback(() => {
    setWindowWidth(window.innerWidth)
  }, [])

  React.useLayoutEffect(() => {
    addEventListener('resize', updateWindowWidth)

    return (): void => removeEventListener('resize', updateWindowWidth)
  }, [updateWindowWidth])

  return (
    <Flex justifyContent="center">
      <Box
        width="full"
        maxWidth={FIXED_WIDTH}
        paddingBottom="16"
        paddingX={windowWidth < FIXED_WIDTH ? '6' : '0'}
      >
        <Stack gap="4">{children}</Stack>
      </Box>
    </Flex>
  )
}

export const FixedContent = React.memo(fixedContent)
